/**
 * Supabase client guard (PLAN-Z M9): the app is fully functional without
 * env vars — every consumer gets `null` and stays in guest mode. The anon
 * key only; the service role key never reaches the client (PLAN.md §5).
 */
import { createClient, type SupabaseClient } from '@supabase/supabase-js'
import type { Attempt } from './local.ts'

let client: SupabaseClient | null = null
let resolved = false

export function getSupabase(): SupabaseClient | null {
  if (!resolved) {
    resolved = true
    const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
    const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined
    if (url && key) client = createClient(url, key)
  }
  return client
}

/** Row shape in the `attempts` table (migrations/0001_init.sql). */
export interface AttemptRow {
  id: string
  session_id: string
  item_id: string | null
  subtest: string
  difficulty: string
  seed: number
  correct: boolean
  sub_answers: Record<string, unknown>
  duration_ms: number
  answered_at: string
  user_id: string
}

export function toRow(a: Attempt, userId: string): AttemptRow {
  return {
    id: a.id,
    session_id: a.sessionId,
    item_id: a.itemId,
    subtest: a.subtest,
    difficulty: a.difficulty,
    seed: a.seed,
    correct: a.correct,
    sub_answers: a.subAnswers,
    duration_ms: a.durationMs,
    answered_at: a.answeredAt,
    user_id: userId,
  }
}

export function fromRow(r: AttemptRow): Attempt {
  return {
    id: r.id,
    sessionId: r.session_id,
    itemId: r.item_id ?? r.id,
    subtest: r.subtest as Attempt['subtest'],
    difficulty: r.difficulty as Attempt['difficulty'],
    seed: Number(r.seed),
    correct: r.correct,
    subAnswers: r.sub_answers ?? {},
    durationMs: r.duration_ms,
    answeredAt: r.answered_at,
  }
}
